import React from 'react';
import { Link } from '@reach/router'
import styled from 'styled-components'
import { Icon } from '@iconify/react';
import { useSelector, useDispatch } from 'react-redux';
import bxHome from '@iconify/icons-bx/bx-home';
import outlineNotificationsActive from '@iconify/icons-ic/outline-notifications-active';
import createDashboard from '@iconify/icons-uil/create-dashboard';
import baselineDeviceHub from '@iconify/icons-ic/baseline-device-hub';

import '../../Reset.css';
import '../../App.css';

const MenuLink = (props) => {

  return (
    <Link
      {...props}
      getProps={(props) => {
        // The object returned here is passed to the
        // Anchor element's props
        return {
          style: {
            'background': props.isPartiallyCurrent ? "#233567" : "none",
            'color': props.isPartiallyCurrent ? "#FFF" : "#555",
          }
        };
      }}
    />
  )
}

const StyledMainMenu = styled.div`
  height: 100%;
  width: 65px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-right: 1px solid #AAA;
`;

const StyledMenuBlock = styled.div`
  width: 65px;
  
  ul {
    display: flex;
    flex-direction: column;
    list-style: none;
    margin: 0 0 0 0px;
    padding: 10px 0 0 10px;
    overflow: auto;
    
    li {
      display: block;
      margin: 10px 0px;
      overflow: auto;
      
      $:last-child {
        margin-top: auto;
      }
      
      a {
        text-decoration: none;
        color: #707070;
        height: 40px;
        display: block;
        width: 40px;
        // padding: 5px;
        border-radius: 5px;
      }
    }
  }
`;

const UserBubble = styled.div`
  
  width: 40px;
  height: 40px;
  border-radius: 20px;
  background: #233567;
  color: #FFF;
  position: relative;
  
  h1 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 20px;
  }
`;

interface Features {
  main: {
    menu: boolean,
    home: boolean,
    devices: boolean,
    notifications: boolean,
    dashboard: boolean,
    user: boolean,
  },
  sub: {
    menu: boolean,
    list: boolean,
    map: boolean,
    power: boolean,
    export: boolean,
    alarms: boolean
  }
}

export interface MainMenuProps {
  /**
   * Features
   */
  features: Features;
  /**
   * user
   */
  user: any;
}

export const MainMenu = (props: MainMenuProps) => {
  
  const features = props.features;
  const user = props.user;
  
  return (
    <StyledMainMenu>
      <StyledMenuBlock>
        <ul>
        
          {features.main.home &&
            <li>
            <MenuLink to="home"><Icon width='40px' height='40px' icon={bxHome} /></MenuLink>
            </li>}
            
          {features.main.devices &&
            <li>
            <MenuLink to="devices"><Icon width='40px' height='40px' icon={baselineDeviceHub} /></MenuLink>
            </li>}

          {features.main.notifications &&
            <li>
              <MenuLink to="notifications"><Icon width='40px' height='40px' icon={outlineNotificationsActive} /></MenuLink>
            </li>}
            
          {features.main.dashboard &&
            <li>
              <MenuLink to="dashboards"><Icon width='40px' height='40px' icon={createDashboard} /></MenuLink>
            </li>}
            
        </ul>
      </StyledMenuBlock>
      <StyledMenuBlock>
        <ul>
            
          {features.main.user &&
            <li>
              <MenuLink to="user"><UserBubble><h1>{user.first_name[0]}</h1></UserBubble></MenuLink>
            </li>}
            
        </ul>
      </StyledMenuBlock>
    </StyledMainMenu>
  )
}